import ChevronRightIcon from '@/asset/icons/chenvron-right';
import ChevronLeftIcon from '@/asset/icons/chevron-left';
import { ClassEnum, LOCALE_OPTIONS } from '@/constants/enum';
import { widgetSettingSelector } from '@/redux/slice/widget.slice';
import { memo } from 'react';
import { DayPicker, DayPickerProps, Matcher } from 'react-day-picker';
import { useSelector } from 'react-redux';
import Button from './Button';
import { localeMapping } from '@/utils';
import { widgetTextDetailSelector } from '@/redux/slice/widgetText.slice';

export interface ICalendarProps {
  selectedDate?: Date;
  onSelected: (date: Date) => void;
  month: Date;
  setMonth: (month: Date) => void;
  disabledDates?: Matcher[];
  // timezone: string;
  style?: React.CSSProperties;
}

const CustomCalendar = ({ selectedDate, onSelected, month, setMonth, disabledDates }: ICalendarProps) => {
  const widgetSettings = useSelector(widgetSettingSelector);
  const widgetTextDetail = useSelector(widgetTextDetailSelector);

  return (
    <Calendar
      id="dd-calendar"
      mode="single"
      captionLayout={widgetSettings.customizations.captionLayout}
      fixedWeeks={widgetSettings.customizations.fixedWeeks}
      showOutsideDays={widgetSettings.customizations.showOutsideDays}
      showWeekNumber={widgetSettings.customizations.showWeekNumber}
      hideWeekdays={!widgetSettings.customizations.showWeekDays}
      weekStartsOn={Number(widgetSettings.customizations.weekStartsOn) as 0 | 1 | 2 | 3 | 4 | 5 | 6}
      selected={selectedDate}
      onSelect={onSelected}
      locale={localeMapping[widgetTextDetail.calendarLocale as LOCALE_OPTIONS]}
      dir={widgetSettings.customizations.rightToLeft ? 'rtl' : 'ltr'}
      hideNavigation={widgetSettings.customizations.hideNavigation}
      startMonth={widgetSettings.customizations.startOnThisMonth ? new Date() : undefined}
      required
      month={month}
      onMonthChange={setMonth}
      today={new Date()}
      endMonth={new Date(new Date().getFullYear() + 10, 11)}
      disabled={disabledDates ? disabledDates : [{ before: new Date() }]}
      // timeZone={timezone}
    />
  );
};

export const Calendar = (props: DayPickerProps) => {
  return (
    <DayPicker
      classNames={{
        root: ClassEnum.Calendar,
        months: ClassEnum.CalendarMonths,
        month: ClassEnum.CalendarMonth,
        month_caption: ClassEnum.CalendarMonthCaption,
        caption_label: ClassEnum.CalendarCaptionLabel,
        nav: ClassEnum.CalendarNav,
        month_grid: ClassEnum.CalendarMonthGrid,
        weekdays: ClassEnum.CalendarWeekdays,
        weekday: ClassEnum.CalendarWeekday,
        week: ClassEnum.CalendarWeek,
        day: ClassEnum.CalendarDay,
        day_button: ClassEnum.CalendarDayButton,
        week_number: ClassEnum.CalendarWeekNumber,
        range_start: ClassEnum.CalendarRangeStart,
        range_end: ClassEnum.CalendarRangeEnd,
        selected: ClassEnum.CalendarSelected,
        today: ClassEnum.CalendarToday,
        outside: ClassEnum.CalendarOutside,
        disabled: ClassEnum.CalendarDisabled,
        range_middle: ClassEnum.CalendarRangeMiddle,
        hidden: ClassEnum.CalendarHidden,
      }}
      components={{
        PreviousMonthButton: (props) => (
          <Button {...props} className={ClassEnum.CalendarPreviousMonthButton} size="icon" customVariant="ghost">
            <ChevronLeftIcon />
          </Button>
        ),
        NextMonthButton: (props) => (
          <Button {...props} className={ClassEnum.CalendarNextMonthButton} size="icon" customVariant="ghost">
            <ChevronRightIcon />
          </Button>
        ),
      }}
      {...props}
    />
  );
};

export default memo(CustomCalendar);
